<script>
export default {
    props: ['courseInstructors', 'publicPage', 'getColor', 'url', 'isMobile'],
    methods: {
        blurOut(instructor)
        {
            if(this.courseInstructors.filter(x => x.hovered) == 0) {
                return false;
            }
            else if(instructor.hovered) {
                return false;
            }
            return true;
        },
    }
}
</script>
<template>
    <div class="CourseList-wrapper" :class="isMobile ? 'CourseInstructors-mobile' : ''">
        
        <div v-for="instructor in courseInstructors" class="CourseList-course-item g-33"> 
            <div @mouseover="instructor.hovered = true" @mouseout="instructor.hovered = false" :class="blurOut(instructor) ? 'ImageGallery-grayscale' : 'ImageGallery-no-grayscale'" >
                <div class="position-relative">
                    <div class="CourseItem-img-area">
                        <img v-if="instructor.image_id" :src="url + 'uploads/'+ publicPage.customer_id+'/images/thumbnails/'+ instructor.image_name" />  
                        <i v-else class="fa-regular fa-image wow-color wow-color-bg"></i>
                    </div>
                    <h4 :style="{'background-color': getColor('background_color') }">{{ instructor.name }}</h4>
                </div>
                <div class="CourseItem-max-course" v-html="instructor.description.length > 200 ? instructor.description.slice(0, 200) + '...' : instructor.description">  </div>  
            </div>              
        </div>
    </div>
</template>

<style scoped>
.Courses-btn{
        background-color: rgb(181, 205, 191);
    padding: 10px 20px;
    font-size: 14px;
    color: black;
    border: 0px solid lightgray;
    font-family: 'Raleway', sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    cursor: pointer;
    }
    
    .Courses-btn:hover {
        filter: brightness(0.8);
    }

.CourseList-wrapper
    {
        display:flex;
        flex-wrap: wrap;
    }
    .CourseList-course-item
    {
        padding:10px; 
        margin: 20px;
        background: white;
        width: calc(33% - 60px);
        box-shadow: 1px 1px #ddd;
    }

    .CourseInstructors-mobile .CourseList-course-item
    {
        margin: 20px 10px;
        padding: 0px;
        width: calc(100% - 20px);
    }

    .CourseItem-img-area
    {
        overflow: hidden;
        text-align: center;
        display: flex;
        align-items: flex-end;
    }

    .CourseItem-max-course
    {
        margin: 30px 10px 10px 10px;
        overflow:auto;
    }

    .CourseItem-wrapper
    {
        display:flex;
        flex-wrap: wrap;

    }

    .CourseItem-img-area i
    {
        display:block;
        padding-top: 40px;
        font-size: 60px;
        background-color:aliceblue;
        height: 100vh;
    }

    img
    {
        height: 250px;
    }

    h4{
        margin-bottom:0px;
        padding:10px;
        width: 50%;
        position: absolute;
        bottom: -20px;
        left: 10px;
        font-size: 14px;
    }

    
.ImageGallery-grayscale {
    filter:grayscale(80%);
    transition: ease-out 0.2s;
}

.ImageGallery-no-grayscale {
    filter:grayscale(0%);
    transition: ease-out 0.2s;
}

    @media only screen and (max-width: 1000px) {
        .CourseItem-img-area {
            height: auto;
            width: auto;
        }
        
        .CourseList-course-item
        {
            padding:10px; 
            margin: 30px;
            width: calc(100% - 80px);
        }       
    }
</style>